import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnChanges, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import UiValidators, { UI_MAX_LOCKOUT_SECONDS } from '@validators';
import { takeUntil } from 'rxjs/operators';
var DISABLED_CONTROLS = ['hasSpecialCharacter', 'hasLowerCase', 'hasUpperCase', 'hasDigits',
    'isEnabled', 'shouldChangePasswordAfterFirstLogin'];
var PASSWORD_COMPLEXITY = ['length', 'hasSpecialCharacter', 'hasDigits', 'hasLowerCase', 'hasUpperCase'];
var PASSWORD = ['defaultExpirationDays', 'previousUseLimit', 'shouldChangePasswordAfterFirstLogin'];
var LOCKOUT = ['isEnabled', 'defaultAccountLockoutSeconds', 'maxAccessAttempts'];
var ROBOT = ['runDisconnected'];
var UiSecuritySettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiSecuritySettingsComponent, _super);
    function UiSecuritySettingsComponent(_fb, cd, appState) {
        var _this = _super.call(this, cd, appState) || this;
        _this._fb = _fb;
        return _this;
    }
    UiSecuritySettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var group = {};
        PASSWORD_COMPLEXITY.forEach(function (key) { return group[key] = [_this.settings.security.passwordComplexity[key]]; });
        PASSWORD.forEach(function (key) { return group[key] = [_this.settings.security.password[key]]; });
        LOCKOUT.forEach(function (key) { return group[key] = [_this.settings.security.lockout[key]]; });
        ROBOT.forEach(function (key) { return group[key] = [_this.settings.security.robot[key]]; });
        this.formGroup = this._fb.group(group);
        this.isReadOnly$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (isReadOnly) {
            if (isReadOnly) {
                DISABLED_CONTROLS.forEach(function (controlName) { return _this.formGroup.get(controlName).disable(); });
            }
            else {
                DISABLED_CONTROLS.forEach(function (controlName) { return _this.formGroup.get(controlName).enable(); });
            }
        });
        this.formGroup.valueChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (values) {
            PASSWORD_COMPLEXITY.forEach(function (key) { return _this.settings.security.passwordComplexity[key] = values[key]; });
            PASSWORD.forEach(function (key) { return _this.settings.security.password[key] = values[key]; });
            LOCKOUT.forEach(function (key) { return _this.settings.security.lockout[key] = values[key]; });
            ROBOT.forEach(function (key) { return _this.settings.security.robot[key] = values[key]; });
        });
        this._initFormValidators();
    };
    UiSecuritySettingsComponent.prototype._initFormValidators = function () {
        this.formGroup.get('length').setValidators([
            UiValidators.range(6, 14),
        ]);
        this.formGroup.get('defaultExpirationDays').setValidators([
            UiValidators.range(0, 120),
            UiValidators.required(),
        ]);
        this.formGroup.get('previousUseLimit').setValidators([
            UiValidators.range(0, 10),
            UiValidators.required(),
        ]);
        this.formGroup.get('defaultAccountLockoutSeconds').setValidators([
            UiValidators.range(1, UI_MAX_LOCKOUT_SECONDS),
        ]);
        this.formGroup.get('maxAccessAttempts').setValidators([
            UiValidators.range(2, 10),
        ]);
        this.formGroup.get('runDisconnected').setValidators([
            UiValidators.range(0, 168),
            UiValidators.required(),
        ]);
    };
    return UiSecuritySettingsComponent;
}(UiSettingForm));
export { UiSecuritySettingsComponent };
